import { AllowedPanValues } from "shared/games/mixpuzzles/types";

export function valueToAllowedPanValues(value: number): AllowedPanValues {
  if (value === 75) {
    return "L";
  }

  if (value === 100) {
    return "LC";
  }

  if (value === 0) {
    return "C";
  }

  if (value === 25) {
    return "RC";
  }

  if (value === 50) {
    return "R";
  }

  return "C";
}

export function allowedPanValuesToValue(value: AllowedPanValues): number {
  if (value === "L") {
    return 75;
  }

  if (value === "LC") {
    return 100;
  }

  if (value === "C") {
    return 0;
  }

  if (value === "RC") {
    return 25;
  }

  if (value === "R") {
    return 50;
  }

  return 0;
}
